/**
 * Client-side constants for the medical opinion (מכתב לגורם חיצוני) feature.
 *
 * No Hebrew labels live here. The opinion type and close reason lists are served by the
 * backend (/medical_opinion_types, /medical_opinion_close_reasons) - use the
 * useMedicalOpinionOptions hooks. The status label arrives on the record itself as
 * heb_status. Keeping any of them here would put a second source of truth back.
 */

// Mirrors the backend limits in medical_opinion.py. Enforced on the client as a UI
// affordance only - the backend re-validates all of them and sniffs the real content type
// rather than trusting the extension.
export const MEDICAL_OPINION_MAX_FILES = 5;
export const MEDICAL_OPINION_MAX_FILE_BYTES = 10 * 1024 * 1024;
export const MEDICAL_OPINION_ACCEPTED_MIME = ['application/pdf', 'image/jpeg', 'image/png'];
export const MEDICAL_OPINION_ACCEPT_ATTR = '.pdf,.jpg,.jpeg,.png';
